import React, { useEffect } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSnackbar } from '../Snackbar';
import { forgotPassword } from '../../api/userApi';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function ForgotPassword() {
  const { showSnackbar } = useSnackbar();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/patient', { replace: true });
    }
  }, [isAuthenticated, navigate]);
  
  const formik = useFormik({
    initialValues: { email: '' },
    validationSchema: Yup.object({
      email: Yup.string().email('Invalid email').required('Email is required'),
    }),
    onSubmit: async (values) => {
      try {
        const res = await forgotPassword(
          {
            email: values.email
          });
        if (res.data.succeeded) {
          showSnackbar(res.data.messages[0], 'success');
          navigate('/');
        } else {
          showSnackbar(res.data.messages[0], 'error');
        }
      } catch (err) {
        showSnackbar(err.response?.data?.message || 'Error sending reset link', 'error');
      }
    }
  });

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 8 }}>
      <Typography variant="h5" gutterBottom>Forgot Password</Typography>
      <form onSubmit={formik.handleSubmit}>
        <TextField
          fullWidth
          label="Email"
          {...formik.getFieldProps('email')}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          margin="normal"
        />
        <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
          Send Reset Link
        </Button>
      </form>
    </Box>
  );
}
